/** Как `recentEmojis` в classic `TicketDetail.js` */
const LS_KEY = 'recentEmojis'
const MAX = 24

export function readRecentEmojis(): string[] {
  try {
    const raw = localStorage.getItem(LS_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as unknown
    if (!Array.isArray(parsed)) return []
    return parsed.filter((e): e is string => typeof e === 'string' && e.length > 0).slice(0, MAX)
  } catch {
    return []
  }
}

export function saveRecentEmoji(emoji: string): void {
  const e = emoji.trim()
  if (!e) return
  try {
    let recent = readRecentEmojis().filter((x) => x !== e)
    recent = [e, ...recent].slice(0, MAX)
    localStorage.setItem(LS_KEY, JSON.stringify(recent))
  } catch {
    /* ignore */
  }
}
